<script lang="ts">
  export let size: String = 'lg';
</script>

<div class="spinner-container {size}" data-testid="spinner">
  <span class="spinner {size}" />
</div>

<style lang="postcss">
  @keyframes spinner {
    to {
      transform: rotate(360deg);
    }
  }

  .spinner-container {
    display: flex;
    align-items: center;
    justify-content: center;

    &.sm {
      min-height: 3rem;
    }

    &.md {
      min-height: 5rem;
    }

    &.lg {
      min-height: 70vh;
    }
  }
  .spinner {
    display: inline-block;
    color: #2e9990;
    border-radius: 50%;
    border: 0.5rem solid #2e9990;
    border-top-width: 0.5rem;
    border-right-width: 0.5rem;
    border-bottom-width: 0.5rem;
    border-left-width: 0.5rem;
    border-right-color: transparent;
    animation: spinner 0.8s linear infinite;

    &.sm {
      width: 2.5rem;
      height: 2.5rem;
    }

    &.md {
      width: 4.5rem;
      height: 4.5rem;
    }

    &.lg {
      width: 6.5rem;
      height: 6.5rem;
    }
  }
</style>
